import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const FileUnknownIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 20 27"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="m19.266 5.099-4.37-4.37a2.5 2.5 0 0 0-1.766-.735H2.5A2.508 2.508 0 0 0 0 2.5v21.666a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5V6.87c0-.661-.266-1.302-.734-1.77ZM18.089 6.28c.109.11.182.24.218.385h-4.974V1.692c.146.037.276.11.386.219l4.37 4.37ZM17.5 25h-15a.836.836 0 0 1-.833-.834V2.5c0-.459.375-.834.833-.834h9.167v5.417c0 .693.557 1.25 1.25 1.25h5.416v15.833A.836.836 0 0 1 17.5 25Z"/>
    </svg>
);
FileUnknownIcon.displayName = 'FileUnknownIcon';
export default FileUnknownIcon;
